import config from '../config';
import { ActionTypes as actions, UserActions, ConsultationsActions, ToastActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import axios from 'axios';

const addAppointment = (token, appointment, callback) => {
  return dispatch => {

    let requestURL = `${config.BASE_URL}/api/scheduling/appointments`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    dispatch({ type: actions.LOADING_SAVE_APPOINTMENT, payload: true });

    axios.post(requestURL, JSON.stringify(appointment), requestConfig).then((response) => {
      let data = response.data || {};
      let appointment = data.appointment || {};

      if (data.success) {
        if (callback) {
          callback();
        }
      }

      dispatch({ type: actions.LOADING_SAVE_APPOINTMENT, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_SAVE_APPOINTMENT, payload: false });
      console.log(error)
    });

  }
}

const getAppointmentInfo = (token, appointment_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/scheduling/appointments/${appointment_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const appointment = data.data || {};

      if (data.success === true && appointment) {
        let consultation_id = appointment.consultation_id;
        dispatch(ConsultationsActions.getConsultationInfo(token, consultation_id));
      }
    }).catch((error) => { console.log(error) });

  }
}

const updateAppointment = (token, appointment, callback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/scheduling/appointments/${appointment._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    dispatch({ type: actions.LOADING_SAVE_APPOINTMENT, payload: true });

    axios.put(requestURL, JSON.stringify(appointment), requestConfig).then((response) => {
      let data = response.data || {};
      let appointment = data.appointment || null;

      if (data.success) {
        if (appointment) {
          dispatch({ type: actions.SCHEDULE_ADD_APT_TO_DICT, payload: appointment });
        }
        if (callback) {
          callback();
        }
      }

      dispatch({ type: actions.LOADING_SAVE_APPOINTMENT, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_SAVE_APPOINTMENT, payload: false });
      console.log(error)
    });

  }
}

const getPracticeAppointments = (token, practice_id, get_all) => {
  return dispatch => {

    let is_get_all    = get_all && get_all === true;
    let requestURL    = `${config.BASE_URL}/api/scheduling/appointments/practice/${practice_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    if (is_get_all) {
        requestURL = `${config.BASE_URL}/api/scheduling/appointments/practice/${practice_id}/all`;
    }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let appointments = data.appointments || [];

      if (data.success === true) {
        let practice_apt_ids     = [];
        let practice_apt_all_ids = [];

        appointments.forEach((appointment) => {
          practice_apt_ids.push(appointment._id);
          practice_apt_all_ids.push(appointment._id);
          let consultation_id = appointment.consultation_id;
          dispatch(ConsultationsActions.getConsultationInfo(token, consultation_id));
          dispatch({ type: actions.SCHEDULE_ADD_APT_TO_DICT, payload: appointment });
        });

        let practice_apt_action = is_get_all ? actions.SCHEDULE_UPDATE_PRACTICE_ALL_APT_IDS : actions.SCHEDULE_UPDATE_PRACTICE_APT_IDS ;
        let practice_apt_array  = is_get_all ? practice_apt_all_ids : practice_apt_ids;

        dispatch({ type: practice_apt_action, payload: practice_apt_array });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getUserAppointments = (token, user_id, get_all) => {
  return (dispatch, getState) => {

    let is_get_all    = get_all && get_all === true;
    let requestURL    = `${config.BASE_URL}/api/scheduling/appointments/user/${user_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    let practice_id   = getState().context.selectedPractice;

    if (is_get_all) {
        requestURL = `${config.BASE_URL}/api/scheduling/appointments/user/${user_id}/all`;
    }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let appointments = data.appointments || [];

      if (data.success === true) {
        let user_apt_ids     = [];
        let user_apt_all_ids = [];

        appointments.forEach((appointment) => {
          if (practice_id === appointment.practice_id) {
            user_apt_ids.push(appointment._id);
            user_apt_all_ids.push(appointment._id);
            let consultation_id = appointment.consultation_id;
            dispatch(ConsultationsActions.getConsultationInfo(token, consultation_id));
            dispatch({ type: actions.SCHEDULE_ADD_APT_TO_DICT, payload: appointment });  
          }
        });

        let user_apt_action = is_get_all ? actions.SCHEDULE_ADD_USER_ALL_APT_ID : actions.SCHEDULE_UPDATE_USER_APT_IDS ;
        let user_apt_array  = is_get_all ? user_apt_all_ids : user_apt_ids;

        dispatch({ type: user_apt_action, payload: user_apt_array });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getConsultationAppointments = (token, consultation_id, callback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/scheduling/appointments/consultation/${consultation_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let appointments = data.appointments || [];

      if (data.success === true && appointments.length > 0 && callback) {
        let appointments_dict = {};

        appointments.forEach((appointment) => {
          appointments_dict[appointment._id] = appointment;
        })

        callback(appointments_dict);
      }
    }).catch((error) => { console.log(error) });

  }
}

export default {
  addAppointment,
  getAppointmentInfo,
  getPracticeAppointments,
  getConsultationAppointments,
  getUserAppointments,
  updateAppointment
}
